import { render, staticRenderFns } from "./TheLanguageButton.vue?vue&type=template&id=0555d8a0&"
import script from "./TheLanguageButton.vue?vue&type=script&lang=js&"
export * from "./TheLanguageButton.vue?vue&type=script&lang=js&"
import style0 from "./TheLanguageButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports